import axios from "../../utils/axiosConfig"; 
axios.defaults.withCredentials = true;

const getDashboardStats = async (pharmacyId: any) => {
  // Get current date
  const currentDate = new Date();
  
  // Extract current month and year
  const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so add 1
  const currentYear = currentDate.getFullYear();

  // Construct the URL with current month, year, and pharmacyId
  const { data } = await axios.get( `/api/pharmacy/pharmacyProfile/get/dashboard/stats?pharmacy_id=${pharmacyId}&month=${currentMonth}&year=${currentYear}`);
  return data;
};

const DashboardStatsService = {
    getDashboardStats,

};

export default DashboardStatsService;
